<template>
  <div class="PicturesUploader">
    <div class="p-header">图片管理器</div>
    <div class="p-body">
      <el-upload
        class="upload-demo"
        name="Filedata"
        :action="imageUpload()"
        :data="{ row_id: userRowID }"
        :on-preview="handlePreview"
        :on-remove="handleRemove"
        :file-list="fileList"
        list-type="picture"
      >
        <el-button class="upload-pic-emmit" size="mini" type="primary">点击上传</el-button>
        <template #tip>
          <!-- <div class="el-upload__tip">
          只能上传 jpg/png 文件，且不超过 500kb
        </div> -->
        </template>
      </el-upload>

      <el-popover placement="bottom" popper-class="files-selector" :width="270" trigger="click">
        <div class="file-show-list">
          <div class="file-item" v-for="item in uploadedFileList" :key="item" @click="handleFileSelect(item)">
            <img :src="item" />
          </div>
        </div>
        <template #reference>
          <el-button size="mini" class="upload-pic-manager" @click="getFilesList">图片选择</el-button>
        </template>
      </el-popover>
      <!-- <el-button class="upload-pic-manager" size="mini">图片管理</el-button> -->
    </div>
  </div>
</template>
<script>
  import {request} from '../../../common/request'
  import Api from '../../../apis/api'
export default {
  name: 'PicturesUploader',
  /*  prop属性只读 不可直接修改 会影响性能以及维护性 */
  props: {
    CurrentConfigration: Object,
    propertyData: Object,
    propertyDataKey: String,
  },
  data() {
    return {
      fileList: [],
      uploadedFileList: [],
      userRowID: '',
      isOpenFileManager: false,
    };
  },
  created() {},
  mounted() {
    /* 获取初始值 */
    this.setUserRowID();
  },
  methods: {
    handlePreview() {},
    handleRemove() {},
    imageUpload(){
      return Api.imageUpload
    },
    handleChange(val) {
      /* 更新数据 */
      this.$store.commit('update_PropertyData', {
        key: this.propertyDataKey,
        value: val,
      });
    },
    handleFileSelect(url) {
      console.log(url);
      this.handleChange(url);
    },
    getFilesList() {
      const url = `${Api.getFilesList}&type=image&row_id=${this.userRowID}`;
      // http://localhost/bigdatadisplaysystem_php/back/gthmmc/index.php?m=bdds&c=uploadWeb&a=getBgmaterial&type=image&row_id=4
        let params = {
          method:'post',
          url:url,
          headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        }
        request(params).then((res) => {
          if (res?.data?.list) {
            console.log(res);
            this.uploadedFileList = res?.data?.list.map(item => Api.host + item);
            console.log(this.uploadedFileList);
          }
        })
    },
    setUserRowID() {
      let info = window.localStorage.getItem('origin_userInfo');
      if (info) {
        let userinfo = JSON.parse(info);
        this.userRowID = userinfo.row_id;
      }
      // console.log('图片上传用户id', this.userRowID);
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
body .el-popper.files-selector {
  background: #2d313b;
  border: 1px solid #575e62;
  max-height: 500px;
  overflow-y: auto;
  &::-webkit-scrollbar-thumb {
    background: #6c45b4 !important;
    width: 4px !important;
    height: 3px !important;
  }
  &::-webkit-scrollbar {
    width: 4px !important;
    height: 3px !important;
  }
  &::-webkit-scrollbar-track {
    background: #43455800;
  }

  & .el-popper__arrow::before {
    background: #2d313b;
    border: 1px solid #575e62;
  }
  .file-show-list {
    width: 100%;
    // height: 800px;
    display: flex;
    flex-wrap: wrap;

    justify-content: space-between;
    padding-top: 10px;
    .file-item {
      cursor: pointer;
      flex-shrink: 0;
      margin-bottom: 20px;
      width: 104px;
      height: 90px;
      background-color: #3e4a69;
      border: 1px solid #3179ff00;
      &:hover {
        border: 1px solid #6d62ff;
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>

<style scoped lang="scss">
// el-popover files-selector el-popper is-light

.PicturesUploader {
  margin-top: 10px;
  width: 100%;
  box-sizing: border-box;
  .p-header {
    box-sizing: border-box;
    padding: 0 15px;
    width: 100%;
    height: 30px;
    color: $property-title-color;
    font-size: $property-title-size;
    line-height: 30px;
  }
  .p-body {
    width: 100%;
    box-sizing: border-box;
    padding: 10px 15px;
    position: relative;
    :deep().el-upload-list__item:first-child {
      margin-top: 20px !important;
    }
    :deep().el-upload-list__item {
      background-color: rgb(63, 67, 75);
      color: white;
      border: 1px solid rgb(171, 120, 253);
      .el-upload-list__item-name {
        color: white;
      }
    }
    :deep().upload-demo {
      .el-progress {
        margin-top: 0px;
        .el-progress__text {
          color: white;
          top: -17px !important;
        }
      }
    }

    .upload-pic-emmit {
      background: linear-gradient(143deg, #3651c5, #686dff);
      color: #ffffff;
      border: #595dcb 1px solid;
      &:hover {
        background: linear-gradient(143deg, #335ae9, #6f6ff5);
        color: white;
        box-shadow: 1px 1px 1px rgb(24, 24, 24);
      }
    }

    .upload-pic-manager {
      position: absolute;
      top: 10px;
      right: 80px;
      background: linear-gradient(143deg, rgb(94, 70, 226), #15a1ffe8);
      color: #ffffff;
      border: #56bb03 0px solid;
      &:hover {
        background: linear-gradient(143deg, #7860ff, #15a1ff);
        color: white;
        // border: #56bb03 1px solid;
        box-shadow: 1px 1px 1px rgb(24, 24, 24);
      }
    }
  }
}
</style>
